const error = {
  namespaced: true,

  state: {
    visible: false,
    errorCode: '',
    message: ''
  },

  mutations: {
    set_error_visible(state, payload) {
      state.visible = payload.visible
      state.errorCode = payload.errorCode
      state.message = payload.message
    }
  },

  actions: {},

  getters: {}
}

export default error
